<script setup>
import { useLocale } from "vuetify";
import { useLang } from "@/stores/lang.js"
import { inject, provide, ref } from "vue";
const localeLang = useLang();
const { t } = useLocale();
const { current } = useLocale()
const props = defineProps({
    languages: {
        type: Object,
        default: null,
    },

});
current.value = localeLang.prefix;
const fnShowLang = inject('fnShowLang');
function setLocale(locale) {
    localeLang.changeLang(locale)
    current.value = locale.prefix;
    fnShowLang(false);
}

</script>

<template>
    <v-row justify="center">
        <v-col cols="12" md="12">
            <v-card class="my-8 mx-4" elevation="6" rounded>
                <v-row justify="center" align-content="center" align="center" class="pt-3">
                    <v-col cols="12" class="px-8">
                        <v-btn v-for="lang in languages" @click="setLocale(lang)"
                            :variant="(lang.prefix === localeLang.prefix) ? 'elevated' : 'tonal'" color="appBarColor"
                            class="my-3" block size="x-large">
                            <span class="text-me-white">{{ lang.name }}</span>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card>
        </v-col>
    </v-row>
</template>
